// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CameraOffOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4a1 1 0 00-1 1v10a1 1 0 001 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7a1 1 0 00-1-1h-5.61l2 2H15z","fill":"currentColor"}}]},"name":"camera-off","theme":"outlined"};

const CameraOffOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CameraOffOutlinedSvg} />;
  CameraOffOutlined.displayName = 'CameraOffOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CameraOffOutlined);
